/**
 * Map Preferred unit to text.
 * @param resources - Object with translation keys.
 * @returns long text for chosen unit.
 */
export const mapPreferredUnitToText = (unit: string, resources: any): string => {
    switch (unit) {
        case 'KG':
            return resources.accountProfileLongTextKilogram;
        case 'LB':
            return resources.accountProfileLongTextPound;
        case 'Liter':
            return resources.accountProfileLongTextLiter;
        default:
            return resources.accountProfileUnitNotFound;
    }
};

/**
 *
 * @param unit unit to normalize
 * @returns normalized unit
 */
export const normalizeAbbrevUnit = (unit: string): string => {
    switch (unit) {
        case 'Liter':
            return 'L';
        default:
            return unit;
    }
};
